import { useEffect, useState } from "react";
import { Gavel, ShieldAlert } from "lucide-react";
import { api } from "@/lib/api";

/** Live governance banner: governed speed window + mandatory park rule. */
export const GovernanceBar = () => {
  const [gov, setGov] = useState(null);

  useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        const { data } = await api.get("/governance");
        if (alive) setGov(data);
      } catch {
        /* banner is non-critical */
      }
    };
    load();
    const id = setInterval(load, 60000);
    return () => {
      alive = false;
      clearInterval(id);
    };
  }, []);

  if (!gov?.enabled) return null;

  const active = gov.in_window;
  return (
    <div
      data-testid="governance-bar"
      className={`flex flex-wrap items-center gap-x-4 gap-y-1 border-b px-4 py-1.5 text-[10px] tracking-[0.14em] sm:px-6 ${
        active
          ? "border-[#FFCC00]/40 bg-[#FFCC00]/5 text-[#FFCC00]"
          : "border-white/10 bg-[#121212] text-[#A1A1AA]"
      }`}
    >
      <span className="flex items-center gap-1.5">
        {active ? <ShieldAlert size={11} /> : <Gavel size={11} />}
        GOVERNANCE {active ? "ACTIVE" : "STANDBY"}
      </span>
      <span data-testid="governance-window">
        {gov.min_kmh}-{gov.max_kmh} KM/H · {gov.window} IST
      </span>
      <span data-testid="governance-park">
        PARKED UNTIL {gov.park_until}
        {gov.park_enforced ? " · ENFORCED" : " · RELEASED"}
      </span>
      <span className="hidden text-[#52525B] md:inline">{gov.now_ist}</span>
    </div>
  );
};
